'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M976 704h-16v-64c0-70.58-57.422-128-128-128-70.58 0-128 57.42-128 128v64h-16c-26.4 0-48 21.6-48 48v224c0 26.4 21.6 48 48 48h288c26.398 0 48-21.6 48-48v-224c0-26.4-21.602-48-48-48zM768 640c0-35.29 28.708-64 64-64 35.29 0 64 28.71 64 64v64h-128v-64z' }),
        React.createElement('path', { d: 'M576 586.636c-20.748-3.528-42.114-6.236-64-8.026v-52.78c70.498-39.728 128-138.772 128-237.832 0-159.058 0-288-192-288s-192 128.942-192 288c0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.75-384 124.422-384 253.39h576v-245.364z' })
    ));
};